/** Default workflow stage IDs used by permission metadata and system seeding. */
export const DEFAULT_LISTING_STAGES = ["draft", "lead", "active", "closed"] as const;
export const DEFAULT_DEAL_STAGES = ["draft", "lead", "active", "closed"] as const;
export const DEFAULT_TASK_STAGES = [
  "not_started",
  "in_progress",
  "waiting_for_feedback",
  "completed",
] as const;
